import React, { Component } from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import { Route, Link } from "react-router-dom"
import styled, { ThemeProvider } from "styled-components"
import { lighten } from "polished"
import PropTypes from "prop-types"

// Styled components for inactive nav items
const UnselectedNavItem = styled.li`
  margin: 10px 0;
  &:hover {
    background-color: ${prop => lighten(0.05, prop.navBackgroundColor)};
  }
`
const UnselectedLink = styled(Link)`
  color: #ffffff !important;
  display: block;
`

// Styled components for the active/selected nav item
const SelectedNavItem = UnselectedNavItem.extend`
  background-color: ${prop => lighten(0.1, prop.navBackgroundColor)};

  &:hover {
    background-color: ${prop => lighten(0.08, prop.navBackgroundColor)};
  }
`
const SelectedLink = UnselectedLink.extend``

class MobileNavItem extends Component {
  handleClick = () => {
    if (this.props.clickHandler) {
      this.props.clickHandler()
    }
  }

  render() {
    const { theme } = this.props
    return (
      <ThemeProvider theme={theme}>
        <Route
          path={this.props.route}
          exact
          children={({ match }) =>
            (match ? (
              <SelectedNavItem className="nav-item" navBackgroundColor={theme.navBackgroundColor}>
                <SelectedLink
                  to={this.props.route}
                  className={this.props.linkClassNames}
                  onClick={this.handleClick}
                >
                  {this.props.text}
                </SelectedLink>
              </SelectedNavItem>
            ) : (
              <UnselectedNavItem className="nav-item" navBackgroundColor={theme.navBackgroundColor}>
                <UnselectedLink
                  to={this.props.route}
                  className={this.props.linkClassNames}
                  onClick={this.handleClick}
                >
                  {this.props.text}
                </UnselectedLink>
              </UnselectedNavItem>
            ))
          }
        />
      </ThemeProvider>
    )
  }
}

MobileNavItem.propTypes = {
  route: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  linkClassNames: PropTypes.string.isRequired,
  clickHandler: PropTypes.func,
  theme: PropTypes.shape({
    primaryColor: PropTypes.string.isRequired,
    primaryColorHover: PropTypes.string.isRequired,
    navBackgroundColor: PropTypes.string.isRequired,
  }).isRequired,
}

MobileNavItem.defaultProps = {
  clickHandler: null,
}

function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
  }
}

export default compose(connect(mapStateToProps))(MobileNavItem)



// WEBPACK FOOTER //
// ./src/components/layout/navigation/MobileNavItem.jsx